import { Account, AccountGroupProfile, ManagementType } from '@ndvr/portfolio-api';

export const getPolicyAccounts = (account: Account, profile?: AccountGroupProfile): Account[] => {
    if (!profile?.accountGroup.allocationGUID) return [account];
    const managedAccounts = profile.accounts.filter((item) => item.managementType === ManagementType.AUTOMATIC);
    return managedAccounts.some((item) => item.accountGUID === account.accountGUID) ? managedAccounts : [account];
};

export const isAccountPolicyCoordinated = (account: Account, profile?: AccountGroupProfile): boolean =>
    getPolicyAccounts(account, profile).length > 1;
